import lazylaod from './lazyload'
import Vue from 'vue'
// import BaseSetting from './wxconfig'
import config from './config'
import { imgDirective } from './decentImg'

lazylaod()
// Vue.use(BaseSetting)
Vue.use(imgDirective, {
    errorImg: config.error || config.loading //设置后会捕捉error
})
